// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
} from 'firebase/functions';

// ===== Interfaces =====

import {
    IUpdatePostResult,
} from '../interfaces';

const publishPostScopeAccessMetadata = async ({
    test,
    docId,
}: {
    test: boolean,
    docId: string,
}): Promise<IUpdatePostResult> => {
    const functions = getFunctions();
    const handlePublish = httpsCallable<
        Record<string, boolean | string>,
        IUpdatePostResult
    >(
        functions,
        'publishPostScopeAccessMetadata',
    );
    const result = await handlePublish({
        test,
        docId,
    });
    return result.data as IUpdatePostResult;
};

export default publishPostScopeAccessMetadata;
